import { GzExchangeContentControlWebComponent } from './component/GzExchangeContentControlWebComponent';

export { GzExchangeContentControlWebComponent };
